import { getResourceCompanyButtons, deleteResourceCompanyButton } from "../../Utils/utils";
import ButtonPage from "./ButtonPage";

const CompanyButtons = () => (
    <ButtonPage
        type='company'
        idKey="resource_company_id"
        getListApi={getResourceCompanyButtons}
        deleteApi={deleteResourceCompanyButton}
    />
);

export default CompanyButtons;
